import { IParticipant, IParticipantInfo } from '../interfaces/participants';
import { SpatialType } from '../interfaces/webSocketConnectionInfo';

export const getInitialMapParticipants = (
  participants: IParticipant[],
  participantsInfo: IParticipantInfo[],
): IParticipant[] => {
  const mapParticipants = participants.map((participant) => {
    const participantRoom = participantsInfo.find(
      (participantInfo) =>
        participantInfo.participantId === participant.participantId,
    );

    if (participantRoom) {
      participant.roomId = participantRoom.roomId;
      participant.region = participantRoom.region
        ? {
            region: participantRoom.region,
            timestamp: Date.now(),
            state: 'joined',
            regionSpatialType: SpatialType.SpatialAudio,
          }
        : null;
      participant.handRaised = participantRoom.handRaised || false;
      participant.handRaisedAt = participantRoom.handRaisedAt;
    }

    return participant;
  });

  return mapParticipants;
};
